import { el } from "./dom.js";
import { debounce } from "../utils/debounce.js";
import { MAG } from "../utils/magazine.js";

// Magazine search bar: a lime-bordered frosted-glass field with a lime search
// glyph and focus glow. Same API as before ({ node, input, cancel }).
export function searchBar({ placeholder = "Search…", onInput, delay = 300 }) {
	const debounced = debounce((value) => onInput(value), delay);

	const icon = el("span", { style: { display: "flex", flex: "none" } });
	icon.innerHTML =
		'<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#b6f23d" stroke-width="2.2"><circle cx="11" cy="11" r="7"/><line x1="16.5" y1="16.5" x2="21" y2="21"/></svg>';

	const input = el("input", {
		type: "search",
		placeholder,
		autocomplete: "off",
		autocapitalize: "off",
		spellcheck: false,
		oninput: (e) => debounced(e.currentTarget.value.trim()),
		style: {
			flex: "1", minWidth: "0", background: "transparent", border: "0", outline: "none",
			fontFamily: "'Archivo', sans-serif", fontWeight: "600", fontSize: "16px", color: "#fff",
		},
	});

	queueMicrotask(() => input.focus());

	const node = el("div", {
		style: {
			display: "flex", alignItems: "center", gap: "10px",
			background: "rgba(255,255,255,.08)", border: `1.5px solid ${MAG.lime}`,
			borderRadius: "13px", padding: "12px 14px", boxShadow: "0 0 0 3px rgba(182,242,61,.18)",
			backdropFilter: "blur(12px)", webkitBackdropFilter: "blur(12px)",
		},
	}, icon, input);

	return { node, input, cancel: () => debounced.cancel() };
}
